import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { animationFixStyle } from 'components/Common';

const BackgroundProgressBar = styled.div`
  background-color: #f1f1f1;
  border-radius: 16px;
  height: 4px;
  position: relative;
  width: 75px;
  left: 50%;
  transform: translateX(-50%);
`;

const AbstractInnerProgressBar = styled.div`
  background-color: ${(props) => props.color || '#f13c6e'};
  border-radius: 16px;
  box-sizing: border-box;
  height: 10px;
  margin-top: -3px;
  position: absolute;
`;

const InnerProgressBar = styled(AbstractInnerProgressBar)`
  width: ${(props) => props.percentage}%;
  min-width: 5px;
`;

const END_WIDTH = '10px';
const MIDDLE_WIDTH = '25px';

const slide = keyframes`
  0% {
    left: 0;
    width: ${END_WIDTH};
  }
  30% {
    left: 0;
    width: ${MIDDLE_WIDTH};
  }
  70% {
    left: calc(100% - ${MIDDLE_WIDTH});
    width: ${MIDDLE_WIDTH};
  }
  100% {
    left: calc(100% - ${END_WIDTH});
    width: ${END_WIDTH};
  }
`;

const AnimationInnerProgressBar = styled(AbstractInnerProgressBar)`
  width: ${MIDDLE_WIDTH};
  animation-name: ${slide};
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-direction: alternate;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  transform: translateZ(0);
  ${animationFixStyle}
`;

export const ProgressContainer = styled.div`
  width: 75px;
`;

const ProgressBar = ({ animation, percentage, color }) => {
  if (animation) {
    return (
      <BackgroundProgressBar>
        <AnimationInnerProgressBar color={color} />
      </BackgroundProgressBar>
    );
  }
  let percent = percentage;
  if (percentage > 100) {
    percent = 100;
  } else if (percentage < 0) {
    percent = 0;
  }
  return (
    <BackgroundProgressBar>
      <InnerProgressBar percentage={percent} color={color} />
    </BackgroundProgressBar>
  );
};

ProgressBar.propTypes = {
  percentage: PropTypes.number,
  animation: PropTypes.bool,
  color: PropTypes.string
};

export default ProgressBar;
